
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11189",
                "data-name": "矩形 11189",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(0 -0.422)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_230",
        "data-name": "蒙版组 230",
        "class": "cls-2",
        "transform": "translate(0 0.422)"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "carpark",
            "transform": "translate(2 1.577)"
          },
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7744",
                "data-name": "路径 7744",
                "class": "cls-3",
                "d": "M66.889,58.139a8.75,8.75,0,1,1-8.75,8.75,8.7,8.7,0,0,1,8.75-8.75m0-1.25a10,10,0,1,0,10,10A10.029,10.029,0,0,0,66.889,56.889Z",
                "transform": "translate(-56.889 -56.889)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7745",
                "data-name": "路径 7745",
                "class": "cls-3",
                "d": "M401.212,284.444h-2.99V295.49h1.2v-4.142h1.794a3.487,3.487,0,0,0,0-6.9Zm0,5.523h-1.794v-4.142h1.794a2.092,2.092,0,0,1,0,4.142Z",
                "transform": "translate(-390.575 -279.967)"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  